import { render } from "./CategoyCard.vue?vue&type=template&id=64ae1c45&scoped=true"
import script from "./CategoyCard.vue?vue&type=script&lang=js"
export * from "./CategoyCard.vue?vue&type=script&lang=js"

import "./CategoyCard.vue?vue&type=style&index=0&id=64ae1c45&lang=scss"
import "./CategoyCard.vue?vue&type=style&index=1&id=64ae1c45&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-64ae1c45"]])

export default __exports__